import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { BaseFormControlComponent } from '../base-form-control.component';

@Component({
  selector: 'boi-form-numeric-input',
  templateUrl: './form-numeric-input.component.html',
  styleUrls: ['./form-numeric-input.component.scss']
})
export class FormNumericInputComponent extends BaseFormControlComponent {
  referenceDataLabels = ReferenceDataLabels;

  @Input() public isCurrency: boolean;
  @Input() public decimals = 0;
  @Input() public fieldMaxLength?: number;
  @Input() public fieldMinValue?: number;
  @Input() public fieldMaxValue?: number;
  @Input() public forceRequired = false;
  @Input() public labelIndex: any;
  @Input() public cssClasses: string;

  @Input() public set numericValue(val: any) {
    this.value = val;
  }

  @Output() public readonly blurChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  public get numericValue(): any {
    return !this.value && this.value !== 0 ? undefined : Number(this.value);
  }

  resetFieldIfLessThanMinValue(): void {
    if (this.fieldMinValue && this.value < this.fieldMinValue) {
      this.value = undefined;
    }
  }

  getNumberOfDecimalsFormat(): string {
    let decimalsFormat: string;
    decimalsFormat = this.decimals !== null && this.decimals > 0 ? `n${this.decimals}` : '##,#';

    return decimalsFormat;
  }

  checkInputLength(event): void {
    const isSelected = event.target.selectionEnd - event.target.selectionStart > 0;
    if (event.target.value.length >= this.fieldMaxLength && !isSelected) {
      event.preventDefault();
    }
  }
}
